import {
  Dialog,
  DialogContent,
  DialogActions,
  TextField,
  Select,
  MenuItem,
  Checkbox,
  FormControlLabel,
  Typography,
  FormControl,
  InputLabel,
  Grid,
  Box,
  Divider,
} from "@mui/material";

import MDButton from "components/MDButton";
import { useState, useEffect } from "react";
import MDBox from "theme/components/MDBox";
import WhereBuilder from "./scope_where_clause";

const ScopeBuilderDialog = ({ open, mode, fields, onSave, onClose }) => {
  const [useExpr, setUseExpr] = useState(false);
  const [by, setBy] = useState("");
  const [byExpr, setByExpr] = useState("");
  const [where, setWhere] = useState("");
  const [anchor, setAnchor] = useState("");
  const [columns, setColumns] = useState("");

  useEffect(() => {
    if (!open) {
      setUseExpr(false);
      setBy("");
      setByExpr("");
      setWhere("");
      setAnchor("");
      setColumns("");
    }
  }, [open]);

  const handleSave = () => {
    if (!useExpr && !by) return;
    if (useExpr && !byExpr) return;

    if (mode === "row" && !anchor) {
      alert("Anchor row is required");
      return;
    }

    const scope = {
      type: useExpr ? "exp" : "field",
      by: useExpr ? byExpr.trim() : by,
      where: where.trim(),
    };

    if (mode === "row") {
      scope.anchor = Number(anchor) || null;
      scope.columns = columns
        ? columns
            .split(",")
            .map((c) => c.trim().toUpperCase())
            .filter(Boolean)
        : [];
    }

    console.log(scope);
    onSave(scope);
    onClose();
  };

  return (
    <Dialog open={open} maxWidth="md" fullWidth>
      <DialogContent>
        <Typography variant="h6" gutterBottom align="center">
          {mode === "sheet" ? "Group Into Sheets" : "Generate multiple rows"}
        </Typography>
        <Divider />
        <Box align="center">
          <Typography variant="h6" fontSize={14} fontWeight={400}>
            Grouping
          </Typography>
        </Box>
        <MDBox mt={2} mb={3}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={3} lg={3}>
              <FormControl sx={{ minWidth: 120, width: "100%" }}>
                <InputLabel>Grouping Type</InputLabel>
                <Select
                  label="Grouping Type"
                  fullWidth
                  value={useExpr}
                  onChange={(e) => {
                    setUseExpr(e.target.value);
                    setBy("");
                    setByExpr("");
                  }}
                  defaultValue={false}
                  sx={{ padding: "12px", paddingLeft: "3px" }}
                >
                  <MenuItem value={false}>By Field</MenuItem>
                  <MenuItem value={true}>Literal Expression</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={9} lg={9}>
              {!useExpr ? (
                <FormControl sx={{ minWidth: 120, width: "100%" }}>
                  <InputLabel>Select Field</InputLabel>
                  <Select
                    label="Select Field"
                    fullWidth
                    value={by}
                    onChange={(e) => setBy(e.target.value)}
                    sx={{ padding: "12px", paddingLeft: "3px" }}
                  >
                    {fields.map((f) => (
                      <MenuItem key={f.key} value={f.key}>
                        {f.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              ) : (
                <Box mt={-1}>
                  <TextField
                    fullWidth
                    margin="dense"
                    label="Enter Expression"
                    placeholder="e.g age >= 18"
                    value={byExpr}
                    onChange={(e) => setByExpr(e.target.value)}
                  />
                </Box>
              )}
            </Grid>
          </Grid>
        </MDBox>

        <WhereBuilder
          fields={fields}
          onChange={(q) => {
            setWhere(q);
          }}
        />

        {mode === "row" && (
          <MDBox mt={5}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={3} lg={3}>
                <TextField
                  fullWidth
                  margin="dense"
                  label="Starting Row"
                  type="number"
                  value={anchor}
                  onChange={(e) => setAnchor(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} md={9} lg={9}>
                <TextField
                  fullWidth
                  margin="dense"
                  label="Columns To Duplicate"
                  placeholder="A,B,D"
                  helperText="
       Leave empty to duplicate entire row.
       Provide columns to selectively copy.
       "
                  value={columns}
                  onChange={(e) => setColumns(e.target.value)}
                />
              </Grid>
            </Grid>
          </MDBox>
        )}
      </DialogContent>
      <DialogActions>
        <MDButton onClick={onClose}>Cancel</MDButton>
        <MDButton variant="contained" onClick={handleSave}>
          Save
        </MDButton>
      </DialogActions>
    </Dialog>
  );
};

export default ScopeBuilderDialog;
